/** Display name for an MT5 account type code. The code itself (e.g. TRADING_VIEW) is what the API expects. */
export function accountTypeLabel(type: string) {
  return type.replace(/_/g, '')
}
